import 'swiper/css';

import React, {useRef} from 'react';
import {A11y, FreeMode, Navigation} from 'swiper/modules';
import {Swiper} from 'swiper/react';

import useLayout from '@/hooks/layout/useLayout';
import {twx} from '@/utils/tailwindUtils';

import styles from './SwiperCarousel.module.scss';

const SwiperCarousel = ({options, className, children, modules = []}) => {
    const {isXl} = useLayout();
    const spaceBetween = isXl ? 24 : 16;
    const sliderRef = useRef(null);
    const builtinOptions = {
        modules: [FreeMode, Navigation, A11y, ...modules],
        pagination: {},
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween,
        navigation: false,
        freeMode: {
            enabled: true,
        },
        mousewheel: false,
        breakpoints: {
            0: {
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
            },
            744: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            },
        },
    };

    const mergedOptions = {...builtinOptions, ...options};

    return (
        <Swiper {...mergedOptions} ref={sliderRef} className={twx('isolate', styles.Carousel, className)}>
            {children}
        </Swiper>
    );
};

export default SwiperCarousel;
